import React from 'react'
import Loadable from 'react-loadable'
import { FullBlockLoader, CircleLoader } from '@deal/components'

export default Loadable({
  loader: () => import(/* webpackChunkName: "path" */ './path'),
  loading: () => <FullBlockLoader loader={CircleLoader} />
})

export const ReenterPath = Loadable({
  loader: () => import(/* webpackChunkName: "reenter-path" */ './ReenterPath'),
  loading: () => <FullBlockLoader loader={CircleLoader} />
})

export type FlowState = {
  flowId?: string
  pathSlug?: string
  pageSlug?: string
}
